import { IMAGE_SELECTOR } from '../../hdrm/constants/image-selector';

export const LIST_ITEM = 'li';

export const LIST_ELEMENTS = ['ul', 'ol'];

export const DEFAULT_BLOCK_TAG = 'p';

export const HEADING_ELEMENTS = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];

export const BLOCKQUOTE_ELEMENT = 'blockquote';

export const BLOCK_ELEMENTS = [...HEADING_ELEMENTS, BLOCKQUOTE_ELEMENT, DEFAULT_BLOCK_TAG];

export const ITALIC_TAG = 'i';

export const STRIKETHROUGH_TAG = 's';

export const ALTERNATIVE_ITALIC = ['em', 'cite', 'dfn'];

export const BOLD_TAG = 'b';

export const ALTERNATIVE_BOLD = ['strong'];

export const UNDERLINE_TAG = 'u';

export const BREAK_TAG = 'br';

export const LINK_TAG = 'a';

export const IMAGE_TAG = 'img';

export const COLORED_ELEMENT = 'ws-color';

export const DECORATION_ELEMENT = 'ws-decoration';

export const TABLE_ELEMENTS = ['table', 'thead', 'th', 'tbody', 'tr', 'td'];

export const EDITABLE_ELEMENTS = [IMAGE_SELECTOR, ...BLOCK_ELEMENTS, LIST_ITEM];

export const SUPPORTED_ELEMENTS = [
  IMAGE_TAG,
  LINK_TAG,
  BREAK_TAG,
  UNDERLINE_TAG,
  ITALIC_TAG,
  BOLD_TAG,
  STRIKETHROUGH_TAG,
  LIST_ITEM,
  IMAGE_SELECTOR,
  COLORED_ELEMENT,
  DECORATION_ELEMENT,
  ...BLOCK_ELEMENTS,
  ...LIST_ELEMENTS,
];
